var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "video-description", on: { click: _vm.onClickTimestamp } },
    [
      _c("div", [_vm._v("公開日：" + _vm._s(_vm.video.createDate))]),
      _vm._v(" "),
      _c("div", {
        domProps: {
          innerHTML: _vm._s(_vm.replaceHTMLSellerInfo(_vm.parsedDesc))
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c98c5d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c98c5d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/video/components/VideoDescription.vue
// module id = null
// module chunks = 